var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import $__default from "jquery";
import { BRANCH_NAME_FIELD, BASE_URL_FIELD, VERSION_FIELD, BST_CUSTOM_BUILD } from "../constants/QueryString.constants.js";
import { EXP_HOSTNAME, LOCAL_ORIGIN } from "../host/Host.constants.js";
import { HostService } from "./HostService.js";
import fetch from "fetch-retry";
import EnvironmentService from "./EnvironmentService.js";
const ROOT_BLOB_ASSET_URL = "https://expassetsprod.blob.core.windows.net";
class AssetService {
  constructor() {
    __publicField(this, "config", {
      assetUrl: "/",
      version: "local",
      isPreRelease: true
    });
  }
  getBaseUrl() {
    let url = this.config.assetUrl;
    if (!url) {
      return url;
    }
    let pathArr = url.split("/");
    if (pathArr.length <= 3) {
      return url;
    }
    let protocol = pathArr[0];
    let host = pathArr[2];
    return `${protocol}//${host}`;
  }
  /**
   * Determines if the assets are originating from localhost domain and we are running in production
   */
  get isLocallyServed() {
    return /localhost/.test(this.config.assetUrl);
  }
  getVersion() {
    return this.config.version;
  }
  getDisplayVersion() {
    return this.getVersion().replace(/refs\/heads/, "");
  }
  get assetUrl() {
    return this.config.assetUrl;
  }
  /**
   * Determines if we are production code.
   * NOTE: DON'T USE THE FLAG TO CHANGE BUSINESS LOGIC. IT CAN CAUSE SOMETHING TO PASS IN BRANCH LINK WHILE FAIL IN PROD. ONLY USE IT FOR LOGGING ENVIRONMENT
   */
  get isProduction__DontUseForBranchingCode_OnlyUseForLoggingEnvironment() {
    return !EnvironmentService.isLocal && !this.isPreReleaseVersion && document.location.hostname === EXP_HOSTNAME;
  }
  /**
   * Determines if we are "testing" a _branchName or _version
   */
  get isPreReleaseVersion() {
    return this.config.isPreRelease;
  }
  /**
   * Get the current CDN path either the latest version, a specified version or version that corresponds with a branch
   * The deploy gulp task for publishing to the CDN provides a .txt file with the corresponding version number
   */
  getAssetUrl() {
    return __async(this, null, function* () {
      let url = null;
      let branchName = EnvironmentService.getQueryParam(BRANCH_NAME_FIELD);
      let baseUrl = EnvironmentService.getQueryParam(BASE_URL_FIELD);
      let version = EnvironmentService.getQueryParam(VERSION_FIELD) || "";
      const origin = window.location.origin;
      if (!!version) {
        const customBuild = EnvironmentService.getQueryParam(BST_CUSTOM_BUILD);
        version = !!customBuild ? `${version}/${customBuild}` : version;
        url = `${ROOT_BLOB_ASSET_URL}/assets/${version}/`;
      }
      if (!!baseUrl && !url) {
        url = baseUrl.endsWith("/") ? baseUrl : `${baseUrl}/`;
      }
      if (!!branchName && !url) {
        const cleanBranchName = branchName.replace(/refs\/heads\//, "").replace(/[/\\*?:"<>|]/g, "_");
        version = yield $__default.ajax(`${ROOT_BLOB_ASSET_URL}/assets/private/package-version-${cleanBranchName}.txt`, {
          cache: false
        });
        const customBuild = EnvironmentService.getQueryParam(BST_CUSTOM_BUILD);
        version = !!customBuild ? `${version}/${customBuild}` : version;
        url = `${ROOT_BLOB_ASSET_URL}/assets/private/${version}/`;
      }
      const windowExpUxVersion = HostService.expUxVersion;
      if (windowExpUxVersion) {
        version = windowExpUxVersion;
        url = HostService.expUxCndAssetUrl;
        this.config.isPreRelease = false;
      }
      if (window.location.origin === LOCAL_ORIGIN && !url) {
        url = `${origin}/`;
        version = origin;
      }
      if (!EnvironmentService.isLocal && !url) {
        version = yield fetch(`${ROOT_BLOB_ASSET_URL}/assets/package-version.txt`, {
          cache: "no-cache",
          retryDelay: 500,
          // @ts-ignore
          retryOn: (attempt, error, response) => {
            const { status = 0 } = response || {};
            const { message = "" } = error || {};
            if (error !== null || status >= 400) {
              if (attempt <= 2) {
                return true;
              } else {
                const $loadingDots = jQuery(".fxs-splashscreen-loader-container");
                const $error = jQuery("#ane-loader-error");
                jQuery("#ane-loader-error").find("a").attr("href", `mailto:mb2ctdri@microsoft.com?subject=Error loading CT&body=${message}

`);
                $loadingDots.hide();
                $error.show();
                if (!!message) {
                  $error.append(`<h3>Details</h3><p>${message}</p>`);
                }
                try {
                  throw error;
                } catch (e) {
                  throw Error(
                    `Loader: maximum number of retries reached attempting to fetch current package version. Attempt: ${attempt}, Response: ${response}`
                  );
                }
              }
            }
          }
        }).then(function(response) {
          return response.text();
        });
        const customBuild = EnvironmentService.getQueryParam(BST_CUSTOM_BUILD);
        version = !!customBuild ? `${version}/${customBuild}` : version;
        url = `${HostService.expUxCdnHost}/${version}/`;
        this.config.isPreRelease = false;
      }
      this.config.version = version;
      if (!url) {
        url = `${document.location.protocol}//${document.location.host}/${version}/`;
      }
      this.config.assetUrl = url;
      return url;
    });
  }
}
const AssetService$1 = new AssetService();
export {
  ROOT_BLOB_ASSET_URL,
  AssetService$1 as default
};
//# sourceMappingURL=AssetService.js.map
